var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"creating-success"},[_c('img',{attrs:{"src":require('../../../../assets/images/admin/success.png'),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("保存成功")])]),_c('div',{staticClass:"bottom-btn"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.prevBtn}},[_vm._v("返回列表")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }